import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useIsMounted } from '@cronos-app/utils';
export const NoSSR = ({ children, ssrPlaceholder, }) => {
    const isMounted = useIsMounted();
    if (isMounted)
        return _jsx(_Fragment, { children: children });
    return _jsx(_Fragment, { children: ssrPlaceholder });
};
